import type {PromotionFilter} from './types';

export const INITIAL_PROMOTION_FILTERS: PromotionFilter[] = [
  {
    title: 'مرتب سازی',
    type: 'radio',
    name: 'sort',
    items: [
      {name: 'discount', title: 'بیشترین تخفیف', selected: false, value: 'desc'},
      {name: 'discount', title: 'کمترین تخفیف', selected: false, value: 'asc'},
      {name: 'price', title: 'بیشترین قیمت', selected: false, value: 'desc'},
      {name: 'price', title: 'کمترین قیمت', selected: false, value: 'asc'}
    ]
  },
  {
    title: 'دسته بندی کالا',
    name: 'category',
    type: 'checkbox',
    items: null
  },
  {
    title: 'موجودی',
    name: 'stock',
    type: 'radio',
    items: [
      {name: 'in_stock', title: 'موجود', selected: false, value: 'in_stock'},
      {name: 'low_stock', title: 'رو به اتمام', selected: false, value: 'low_stock'},
      {name: 'no_stock', title: 'ناموجود', selected: false, value: 'no_stock'}
    ]
  },
  {
    name: 'tn',
    key: 'discount_type',
    title: 'تخفیف نارنجی',
    type: 'selectable',
    selected: false
  },
  {
    name: 'brand',
    key: 'discount_share_type',
    title: 'تخفیف برند',
    type: 'selectable',
    selected: false
  },
  {
    name: 'bundle',
    key: 'discount_type',
    title: 'پک به صرفه',
    type: 'selectable',
    selected: false
  },
  {
    name: 'daily',
    key: 'discount_type',
    title: 'حراج روزانه',
    type: 'selectable',
    selected: false
  }
];
